import styled, { css } from "styled-components";
import * as React from "react";
import defaultTheme from "../../../defaultTheme";
import transition from "../../../utils/transition";
export const StyledButtonPrimitiveIconContainer = styled(({
  className,
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: className
}, children)).withConfig({
  displayName: "ButtonPrimitiveIconContainer__StyledButtonPrimitiveIconContainer",
  componentId: "sc-8rx3cv-0"
})(["", ""], ({
  margin,
  width,
  height
}) => css(["display:flex;flex-direction:row;align-items:center;justify-content:center;margin:", ";color:currentColor;transition:", ";> svg{width:", ";height:", ";}"], margin, transition(["background", "box-shadow", "color"], "fast", "ease-in-out"), width, height)); // $FlowFixMe: https://github.com/flow-typed/flow-typed/issues/3653#issuecomment-568539198

StyledButtonPrimitiveIconContainer.defaultProps = {
  theme: defaultTheme
};

const ButtonPrimitiveIconContainer = ({
  margin,
  width,
  height,
  children
}) => /*#__PURE__*/React.createElement(StyledButtonPrimitiveIconContainer, {
  margin: margin,
  width: width,
  height: height
}, children);

export default ButtonPrimitiveIconContainer;